// extracted by mini-css-extract-plugin
export default {"animateSvg":"animateSvg__3O2lt"};